export const resolveOrders = (page = undefined, perpage = undefined) => {
    return ['$stateParams', 'ordersApiService', ($stateParams, ordersApiService) => {
        if (!$stateParams.filtertype && !$stateParams.filtertext) {
            return ordersApiService.findPayment(page, perpage).then(list => list);
        }

        return ordersApiService.search($stateParams.filtertype, $stateParams.filtertext, page).then(list => list);
    }];
};

export const resolveOrder = (param = 'order') => {
    return ['$stateParams', 'ordersApiService', ($stateParams, ordersApiService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? ordersApiService.findById($stateParams[param]) : {};
    }];
};

export const resolveEmailContent = () => {
    return ['$stateParams', 'ordersApiService', ($stateParams, ordersApiService) => {
        return ordersApiService.getEmailContent($stateParams['order'], $stateParams['template']).then(response => response.data);
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/resolvers/orders.resolver.js